import React, {Component} from 'react';
import './style.css';
import {connect} from "react-redux";
import {translateLang} from "../../../constants/traductions";

class UpdateInfo extends Component {
  render() {

    return (
      <div className="updated-at">

        {
          this.props.store.dataDisp.length !== 0 ? (
            this.props.store.dataDisp.data ?
            <p><i className="material-icons">access_time</i> { translateLang('updated', this.props.store.language) } {this.props.store.dataDisp.data[0].fechaImpresion}</p> :
            <p><i className="material-icons">access_time</i> { translateLang('updated', this.props.store.language) } -</p>
          ) : <i className="material-icons">access_time</i>
        }

      </div>
    );

  }
}

const mapStateToProps = store => ({
  store
});

export default connect(mapStateToProps, null)(UpdateInfo);
